import { Tab, Tabs} from 'react-bootstrap';
import { Card, Row, Col, Nav } from 'react-bootstrap';
import { ApplicationData } from './ApplicationData';
import { GithubFilled, GlobalOutlined} from '@ant-design/icons';
import TechStack from './TechStack';
import { GeneralContainer, TabContainer } from '../styles/styled.components';

const TabPages = () => {
    
    return (
        <TabContainer>
        <Tabs
        defaultActiveKey="featured"
        variant='pills'
        id="justify-tab-example"
        className="mb-3 tabscolor"
        justify
        
        >
            <Tab eventKey="profile" title="Bio">
                <Card bg="dark" style={{ padding: '3rem'}}>   
                    Innovative senior software developer with a strong background in databases serving hundreds of hospitals and thousands of health professionals. Recognized for impact on hospital operations. Apart of a clinical surveillance and patient safety Saas solution that has earned prestigious best in KLAS designation from KLAS research for multiple consecutive years.<br></br><br></br>Excels in creating scalable and efficient stored procedures used for NHSN reporting. Provided continuous EHR monitoring used by pharmacists and clinicians to catch potential adverse drug events before they become critical. Enhanced real-time analytics which have helped health systems standardization of medication practices and improve overall patient outcomes.
                </Card>
            </Tab>
            <Tab eventKey="featured" title="Featured Applications">
                {Array.from(ApplicationData).map(({ id, applicationTitle, mainPhoto, description, applicationImage, applicationLink, github }) => (
                    <Card style={{ alignItems: 'center', padding: '.5rem'}} className='mb-4' bg="dark">
                    <Col key={id} style={{ height: '180' }}>
                        <Row style={{ paddingTop: '1.2rem' }} md={1} lg={2} xl={2}>
                            <Col lg={6} xl={6}>
                            <Card.Img height='200' style={{ marginBottom: '1rem', objectFit:'cover', borderRadius: '.5rem' }} src={mainPhoto} alt={applicationTitle}/>
                            </Col>
                            <Col lg={6} xl={6}>
                                <Card.Body>
                                    <GeneralContainer href={`/application/${id}`}>
                                    <Card.Title style={{ marginBottom: '1rem' }}>{applicationTitle}</Card.Title> 
                                    </GeneralContainer>
                                    <Card.Text>{description}</Card.Text>
                                </Card.Body>
                                <Card.Footer>
                                    <Nav style={{ justifyContent: 'left', fontSize: 35 }}>
                                        <GeneralContainer style={{marginRight: '1rem'}} href={applicationLink} target='_blank' rel="noreferrer">
                                            <GlobalOutlined/>
                                        </GeneralContainer>
                                        <GeneralContainer href={github} target='_blank' rel="noreferrer">
                                            <GithubFilled/>
                                        </GeneralContainer>
                                    </Nav>
                                </Card.Footer>
                            </Col>
                        </Row>
                    </Col>
                    </Card>
                ))}
            </Tab>
            <Tab eventKey="longer-tab" title="Tech Stack">
                <TechStack/>
            </Tab>
        </Tabs>
        </TabContainer>
    );
}

export default TabPages;